/**
 * @fileoverview Start overlay component with game and stories options.
 * Shown on load to gate audio on iOS and provide entry points to the app.
 */

import { render } from 'preact';
import { menuStrings } from '../i18n/menu.js';
import { tapProps } from '../utilities/tapProps.js';

interface StartOverlayProps {
    onStartGame: (e?: Event) => void;
    onStories: (e?: Event) => void;
}

function StartOverlay({ onStartGame, onStories }: StartOverlayProps) {
    return (
        <div class="start-buttons">
            <button class="start-button primary" {...tapProps(onStartGame)}>
                {menuStrings.startGame || 'Start Game'} 🎮
            </button>
            <button class="start-button secondary" {...tapProps(onStories)}>
                {menuStrings.readStories || 'Read Bedtime Stories'} 📚
            </button>
        </div>
    );
}

export function mountStartOverlay(onStartGame: (e?: Event) => void, onStories: (e?: Event) => void): void {
    const el = document.getElementById('startOverlay');
    if (!el) return;
    render(<StartOverlay onStartGame={onStartGame} onStories={onStories} />, el);
}
